// Styles
import { ArticleAuthor } from 'modules/main/layouts/ArticleContent/components/ArticleAutor';
import {
  BannerArticle,
  BannerArticleContainer,
  SpecialProjects,
  TitleArticleh4,
  Wrap,
} from './style';

//Hook
import { useTranslations } from 'languages/index';

//API
import { FC } from 'react';
import { useProContext } from 'store/ProReducer/useProContext';
import { ArticleResponseType } from 'types/api/articleResponseType';
import { BeautypediaArticleType } from 'types/api/beautyArticleResponseType';
import { BrandsArrayType, CompaniesArrayType } from 'types/api/itemsResponseType';
import RelatedCompaniesAndBrands from './RelatedCompaniesAndBrands';
import dynamic from 'next/dynamic';

type PropsType = {
  data?: ArticleResponseType | BeautypediaArticleType;
  isColumnist?: boolean;
  hide?: boolean;
  brandItems?: BrandsArrayType;
  companiesItems?: CompaniesArrayType;
  isLoadOtherContent?: boolean;
  isArticle?: boolean;
};

const ArticlesList = dynamic(
  () => import('modules/main/components/RightSidebar/ArticlesList'),
  {
    ssr: false,
  }
);

export const RightSidebar: FC<PropsType> = ({
  data = {
    id: '',
  },
  isColumnist,
  hide,
  brandItems = [],
  companiesItems = [],
  isLoadOtherContent,
  isArticle,
}) => {
  const { id = '' } = { ...data };

  const { modulId } = useProContext();

  const t = useTranslations();

  return (
    <Wrap>
      {isColumnist || hide ? '' : <ArticleAuthor data={data} />}
      {(!!brandItems?.length || !!companiesItems?.length) && (
        <RelatedCompaniesAndBrands
          brandItems={brandItems}
          companiesItems={companiesItems}
        />
      )}
      <BannerArticleContainer>
        <BannerArticle modulId={modulId} count="numberBannerFirst" />
      </BannerArticleContainer>
      <TitleArticleh4>{t('Article.SpecialProgect')}</TitleArticleh4>
      {isArticle ? <>{isLoadOtherContent && <SpecialProjects />}</> : <SpecialProjects />}
      {isLoadOtherContent && (
        <>
          <TitleArticleh4>{t('Article.New')}</TitleArticleh4>
          <ArticlesList
            articleId={id}
            modulId={modulId}
            new_posts
            isShort
            isRightSideBarIn
          />
          {hide ? '' : <TitleArticleh4>{t('Article.MostRead')}</TitleArticleh4>}
          {hide ? (
            ''
          ) : (
            <ArticlesList
              articleId={id}
              modulId={modulId}
              most_Readeble
              isShort
              isRightSideBarIn
            />
          )}
        </>
      )}
    </Wrap>
  );
};

export default RightSidebar;
